import React from 'react';
import PropTypes from 'prop-types';
import Rule from 'wonderbly-components/lib/Rule';
import cx from 'classnames';
import { optimiseImage } from 'src/common/utils/prismic-image';
import './ChildReview.scss';

const ChildReviews = props => (
  <div
    className={cx('child-reviews', {
      hidden: props.hidden,
    })}>
    {props.reviews.map((review, index) => (
      <div className="child-review" key={index}>
        <div className="child-review-meta">
          <div className="reviewer-rating">
            <img
              src={optimiseImage(review.ratingImage.url, {
                auto: 'format,compress',
                w: review.ratingImage.dimensions.width,
              })}
              alt={review.ratingImage.alt || ''}
              data-animate-text="first"
            />
          </div>
          <div className="reviewer-info">
            <h5 className="text-kilo review-name" data-animate-text="second">
              {review.reviewerName}
            </h5>
            <h6 className="text-milli review-age" data-animate-text="third">
              {review.reviewerAge}
            </h6>
          </div>
        </div>
        <div className="child-review-content">
          <img
            src={optimiseImage(review.reviewImage.url, {
              auto: 'format,compress',
              w: review.reviewImage.dimensions.width,
            })}
            alt={review.reviewImage.alt || ''}
            width={review.reviewImage.dimensions.width / 2}
            data-animate-text="forth"
          />
        </div>
        <Rule type="medium" />
      </div>
    ))}
  </div>
);

ChildReviews.propTypes = {
  hidden: PropTypes.bool.isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      ratingImage: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
      }).isRequired,
      reviewerName: PropTypes.string.isRequired,
      reviewerAge: PropTypes.string.isRequired,
      reviewImage: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        dimensions: PropTypes.shape({
          width: PropTypes.number.isRequired,
        }).isRequired,
      }).isRequired,
    }),
  ).isRequired,
};

export default ChildReviews;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductReviewList/ChildReviews/ChildReviews.js